import { useViewportStore } from "../providers/WindowSizeProvider"
import { shallow } from "zustand/shallow"

export default function useWindowSize(selector = (state) => state.viewport) {
	return useViewportStore(selector, shallow)
}

export function useWindowWidth() {
	return useWindowSize((state) => state.viewport.width)
}

export function useWindowHeight() {
	return useWindowSize((state) => state.viewport.height)
}

export function useWindowActive() {
	return useWindowSize((state) => state.viewport.active)
}
